import React, { useState, useContext, useEffect } from 'react';
import {
  Widget,
  Table,
  usePromise,
  MasterDetailForm,
  FormSubmitButton,
  FormatText,
  FormInput,
  FormSelect,
  FormSwitch,
  FormNumber,
  InlineEditTable,
  FormDatePicker,
  ColumnType,
  CrudContext,
  OptionProps,
  InlineEditColumnProps,
  Button,
  ButtonDelete,
} from '@digital/ui';
import {
  Correspondencia,
  getAllCorrespondencias,
  createCorrespondenciaEnvio,
  updateResposta,
  updateEnvio,
  deleteCorrespondencia,
  download,
  getEmitenteDestinatarioCorrespondencias,
  view,
  marcarRespostaVisualizada,
} from '../../../api/contrato/correspondencia';
import { Collapse, Icon, Dropdown, Tooltip } from 'antd';
import * as Yup from 'yup';
import { UploadFile } from '@app/components';
import { getAllAreasOptions } from '@app/api/area';
import { hasPermission } from '@app/helpers/permissions';
import { GetFileExtension, getLoggedIsMRN, imageFormats } from '@app/helpers';
import './custom.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { itensMedicoes } from '@app/api/mock/boletimMedicao';
import ModalConcluir from './ModalConcluir';
import { fixedEncodeURIComponent } from '@app/helpers/stringHelper';

const AbaCorrespondencias = () => {
  const [areasOptions, setAreasOptions] = useState();
  const [updateList, setUpdateList] = useState(false);
  const [exigeResposta, setExigeResposta] = useState<boolean>(false);
  const { Panel } = Collapse;
  const { selectedItem } = useContext(CrudContext);
  const [isMRN] = useState<boolean>(getLoggedIsMRN());
  const [prazoDias, setPrazoDias] = useState<string | null>(null);

  const handleDownloadFileEnvio = (values: any) =>
    download(fixedEncodeURIComponent(values.localArquivoEnvio) + '\\' + values.nomeArquivoEnvio, values.nomeArquivoEnvio);

  const handleDownloadFileResposta = (values: any) =>
    download(fixedEncodeURIComponent(values.localArquivoResposta) + '\\' + values.nomeArquivoResposta, values.nomeArquivoResposta);

  const viewArquivo = (path: string, nome: string) => view(path + '\\' + nome, nome);

  const handleMarcarRespostaVisualizada = (id: string) => {
    marcarRespostaVisualizada({ id }).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  const uploadNaoEhVisivel = (item: any) => {
    return ((item.respostaSalva || item.statusCodigo === 3)
    )
            
  };

  const onUpdate = () => {
    setUpdateList(!updateList);
  };

  const columnEnvio = () => {
    const [areasOptions] = usePromise(getAllAreasOptions, [], [] as OptionProps[]);
    return [
      {
        title: 'Cód. Envio',
        dataIndex: 'envioCodigo',
        key: 'envioCodigo',
        width: '20%',
        renderEdit: () => <FormInput name="envioCodigo" disabled={isMRN} required />,
      },
      {
        title: 'Emitente',
        dataIndex: 'emitente',
        key: 'emitente',
        renderEdit: () => <FormInput name="emitente" disabled required />,
        width: '10%',
      },
      {
        title: 'Destinatário',
        dataIndex: 'destinatario',
        key: 'destinatario',
        renderEdit: () => <FormInput name="destinatario" disabled required />,
        width: '10%',
      },
      {
        title: 'Data',
        dataIndex: 'envioData',
        key: 'envioData',
        type: ColumnType.Date,
        width: '5%',
      },
      {
        title: 'Rastreio',
        dataIndex: 'envioCodigoRastreio',
        key: 'envioCodigoRastreio',
        renderEdit: (name, item) => (
          <FormInput
            name="envioCodigoRastreio"
            disabled={(item.numeroFornecedorEmitente == 0 && !isMRN) || (item.numeroFornecedorEmitente != 0 && isMRN)}
          />
        ),
        width: '5%',
      },
      {
        title: 'Prazo',
        dataIndex: 'envioPrazoData',
        key: 'envioPrazoData',
        type: ColumnType.Date,
        renderEdit: (name, item) => (
          <FormDatePicker
            name="envioPrazoData"
            format="DD/MM/YYYY"
            required
            disabled={(item.numeroFornecedorEmitente == 0 && !isMRN) || (item.numeroFornecedorEmitente != 0 && isMRN)}
          />
        ),
        width: '5%',
      },
      {
        title: 'Assunto',
        dataIndex: 'envioAssunto',
        key: 'envioAssunto',
        renderEdit: (name, item) => (
          <FormInput
            name="envioAssunto"
            required
            disabled={(item.numeroFornecedorEmitente == 0 && !isMRN) || (item.numeroFornecedorEmitente != 0 && isMRN)}
          />
        ),
        width: '20%',
      },
      {
        title: 'Áreas',
        dataIndex: 'areas',
        key: 'areas',
        options: areasOptions,
        width: '15%',
        render: valor => {
          let areas: string[] = [];
          valor.forEach(item => {
            areasOptions.forEach(option => {
              if (option.value == item) areas.push(option.text);
            });
          });
          return areas.join(',');
        },
        renderEdit: (name, item) => (
          <FormSelect
            mode="multiple"
            name="areas"
            options={areasOptions}
            required
            disabled={(item.numeroFornecedorEmitente == 0 && !isMRN) || (item.numeroFornecedorEmitente != 0 && isMRN)}
          />
        ),
      },
      {
        renderEdit: (name, item) => (
          <UploadFile
            hasFile={false}
            label={' '}
            disabled={(item.numeroFornecedorEmitente == 0 && !isMRN) || (item.numeroFornecedorEmitente != 0 && isMRN)}
          />
        ),
        width: '5%',
      },
      {
        title: 'Opções',
        dataIndex: '',
        key: 'x',
        width: '10%',
        render: (item: any) => (
          <>
            {item.nomeArquivoEnvio && (
              <>
                <Tooltip title="Baixar Arquivo">
                  <Button
                    onClick={() => {
                      handleDownloadFileEnvio(item);
                    }}
                    icon="ui-download"
                  />
                </Tooltip>
                {GetFileExtension(item.nomeArquivoEnvio) === 'pdf' ||
                  imageFormats.includes(GetFileExtension(item.nomeArquivoEnvio)) ? (
                  <Tooltip title="Visualizar Arquivo">
                    <Button
                      onClick={async () => {
                        await viewArquivo(item.localArquivoEnvio, item.nomeArquivoEnvio);
                      }}
                      icon="files-view_file"
                      name="btnViewArquivo"
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </>
            )}
            {hasPermission(['CONTRATO_CORRESPONDENCIA_EDITAR']) && (
              <Tooltip title="Deletar Item">
                <ButtonDelete
                  type="link"
                  confirm="Deseja realmente excluir este registro?"
                  okText="Confirmar"
                  onClick={() => handleDelete(item.id)}
                  icon="science-minus"
                  className="btn-delete-without-text"
                />
              </Tooltip>
            )}
            {isMRN && (
              <ModalConcluir
                onUpdate={onUpdate}
                concluido={item.statusCodigo === 3}
                id={item.id}
                justificativa={item.justificativaConclusao}
              />
            )}
          </>
        ),
      },
    ] as InlineEditColumnProps<Correspondencia>[];
  };

  const columnResposta = [
    {
      title: 'Cód. Resposta',
      dataIndex: 'respostaCodigo',
      key: 'respostaCodigo',
      renderEdit: (name, item) => (
        <FormInput name="respostaCodigo" disabled={isMRN || item.respostaSalva || item.statusCodigo === 3} />
      ),
      width: '20%',
    },
    {
      title: 'Data',
      dataIndex: 'respostaData',
      key: 'respostaData',
      type: ColumnType.Date,
      width: '10%',
    },
    {
      title: 'Rastreio',
      dataIndex: 'respostaCodigoRastreio',
      key: 'respostaCodigoRastreio',
      renderEdit: (name, item) =>
        (item.numeroFornecedorEmitente == 0 && isMRN) ||
          (item.numeroFornecedorEmitente != 0 && !isMRN) ||
          item.respostaSalva ||
          item.statusCodigo === 3 ? (
          <FormInput name="respostaCodigoRastreio" disabled />
        ) : (
          <FormInput name="respostaCodigoRastreio" />
        ),
      width: '15%',
    },
    {
      title: 'Assunto',
      dataIndex: 'respostaAssunto',
      key: 'respostaAssunto',
      renderEdit: (name, item) =>
        (item.numeroFornecedorEmitente == 0 && isMRN) ||
          (item.numeroFornecedorEmitente != 0 && !isMRN) ||
          item.respostaSalva ||
          item.statusCodigo === 3 ? (
          <FormInput name="respostaAssunto" disabled />
        ) : (
          <FormInput name="respostaAssunto" />
        ),
      width: '40%',
    },
    {
      renderEdit: (name, item: any) =>
        {
          return (
             uploadNaoEhVisivel(item)?
            (
              <UploadFile idDoComponente='sgc-upload-UploadModalSubstituirAnexo' hasFile={false} label={' '} disabled={true} />
            ) :
            (
              <UploadFile idDoComponente='sgc-upload-UploadModalSubstituirAnexo' label={' '} disabled={false} />
            )
          )
        },
      width: '5%',
    },
    {
      title: 'Opções', 
      width: '10%',
      key: 'x',
      dataIndex: '',
      render: (item: any) => (
        <>
          {item.nomeArquivoResposta && (
            <>
              <Tooltip title="Baixar Arquivo">
                <Button
                  onClick={() => {
                    handleDownloadFileResposta(item);
                  }}
                  icon="ui-download"
                />
              </Tooltip>
              {GetFileExtension(item.nomeArquivoResposta) === 'pdf' ||
                imageFormats.includes(GetFileExtension(item.nomeArquivoResposta)) ? (
                <Tooltip title="Visualizar Arquivo">
                  <Button
                    onClick={async () => {
                      await viewArquivo(item.localArquivoResposta, item.nomeArquivoResposta);
                    }}
                    icon="files-view_file"
                    name="btnViewArquivo"
                  />
                </Tooltip>
              ) : (
                <></>
              )}
            </>
          )}
          {item.numeroFornecedorEmitente !== 0 && item.respostaVisualizadaPeloFornecedor != true && isMRN == false && (
            <Tooltip title="Marcar resposta como Visualizada">
              <Button onClick={() => handleMarcarRespostaVisualizada(item.id)} icon="ui-approval" />
            </Tooltip>
          )}
        </>
      ),
    },
  ] as InlineEditColumnProps<Correspondencia>[];

  const [correspondencias] = usePromise(
    () => (selectedItem ? getAllCorrespondencias(selectedItem.id) : Promise.resolve(undefined)),
    [selectedItem, updateList],
    [] as Correspondencia[],
  );

  const [formData, setFormData] = useState();
  const [emitenteDestinatario, setEmitenteDestinatario] = useState();
  const [hasFile, setHasFile] = useState(false);
  const [updateEmitente, setUpdateEmitente] = useState();

  useEffect(() => {
    selectedItem && setAreasOptions(getAllAreasOptions);
    selectedItem &&
      setEmitenteDestinatario(
        getEmitenteDestinatarioCorrespondencias(selectedItem.id)
          .then(resp =>
            setFormData({ emitente: resp.emitente, destinatario: resp.destinatario }),
          ),
      );
  }, [selectedItem, updateEmitente]);

  useEffect(() => {
    !exigeResposta && setPrazoDias(null);
  }, [exigeResposta])

  const handleCreateCorrespondenciaEnvio = (values: any) =>
    createCorrespondenciaEnvio(selectedItem.id, values.formData, values)
      .then(result => {
        if (result && result.valid) {
          setUpdateList(false);
          setUpdateList(true);

          setHasFile(true);
          setHasFile(false);

          setUpdateEmitente(null);
          setUpdateEmitente(true);

          setFormData(null);
          setFormData(emitenteDestinatario);
        }
      });

  const handleUpdateResposta = (values: any) =>{
    updateResposta(selectedItem.id, values.arquivo, values).then(result => {
      if (result && result.valid) {
        setUpdateList(false);
        setUpdateList(true);
      }
    });}

  const handleUpdateEnvio = (values: any) => updateEnvio(selectedItem.id, values.formData, values);

  const handleDelete = async (id: any) => {
    return deleteCorrespondencia(id).then(result => {
      setUpdateList(false);
      setUpdateList(true);
    });
  };

  return (
    <>
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel
          key="novoItem"
          header={'Cadastro de Correspondência de Envio' || <FormatText id="ui.commons.filter" camelcase />}
          style={{ border: 0 }}>
          <MasterDetailForm
            onSubmit={handleCreateCorrespondenciaEnvio}
            initialValues={formData}
            validationSchema={Yup.object().shape({
              envioCodigo: isMRN == false ? Yup.string().required('Código deve ser informado') : Yup.string(),
              envioAssunto: Yup.string().required('Assunto deve ser informado'),
              // areaId: Yup.string().required('Área deve ser informada'),
            })}>
            <Widget
              className="ant-app-actions-widget"
              actions={[
                hasPermission(['CONTRATO_CORRESPONDENCIA_CADASTRAR_ENVIO']) && (
                  <FormSubmitButton noIcon={true} type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <FormInput label="Emitente" name="emitente" span={6} disabled />
              <FormInput label="Destinatário" name="destinatario" span={6} disabled />
              {isMRN == false && <FormInput label="Código" name="envioCodigo" span={3} required />}
              <FormInput label="Código de Rastreio" name="envioCodigoRastreio" span={3} />
              <FormSwitch
                onClick={value => {
                  setExigeResposta(value);
                }}
                label="Exigir Resposta?"
                name="envioRequerResposta"
                span={3}
              />
              <FormInput
                type="number"
                min="0"
                label="Prazo Para Resposta"
                name="envioPrazoDias"
                span={3}
                disabled={!exigeResposta}
                value={prazoDias}
                onChange={c => {
                  setPrazoDias(c.target.value);
                }}
              />
              <FormInput label="Assunto" name="envioAssunto" span={6} required />
              <FormSelect mode="multiple" label="Áreas" name="areas" options={areasOptions} required span={6} />
              <UploadFile
                label="Adicionar Arquivo"
                hasFile={hasFile}
                accept={'.docx, .xlsx, .pdf, .pptx, .jpg, .zip'}
                nameFormData={'file'}
                idDoComponente={'file'}
              />
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>

      <Widget title="Correspondências">
        {hasPermission(['CONTRATO_CORRESPONDENCIA_EDITAR']) ? (
          <PerfectScrollbar>
            <InlineEditTable
              className="removeScrollbar"
              rowKey={'id'}
              columns={columnEnvio()}
              updateItem={handleUpdateEnvio}
              dataSource={correspondencias}
              expandedRowRender={item => {
                return hasPermission(['CONTRATO_CORRESPONDENCIA_CADASTRAR_RESPOSTA']) ? (
                  <InlineEditTable
                    columns={columnResposta}
                    dataSource={[item]}
                    pagination={false}
                    updateItem={handleUpdateResposta}
                  />
                ) : (
                  <Table columns={columnResposta} dataSource={[item]} pagination={false} />
                );
              }}
              pagination={false}
            />
          </PerfectScrollbar>
        ) : (
          <PerfectScrollbar>
            <Table
              columns={columnEnvio()}
              expandedRowRender={item => {
                return hasPermission(['CONTRATO_CORRESPONDENCIA_CADASTRAR_RESPOSTA']) ? (
                  <InlineEditTable
                    columns={columnResposta}
                    dataSource={[item]}
                    pagination={false}
                    updateItem={handleUpdateResposta}
                  />
                ) : (
                  <Table columns={columnResposta} dataSource={[item]} pagination={false} />
                );
              }}
              dataSource={correspondencias}
              pagination={false}
            />
          </PerfectScrollbar>
        )}
      </Widget>
    </>
  );
};

export default AbaCorrespondencias;
